import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthRedirect = ({ children, className, ...props }) => {
  const { user } = useAuth();
  
  // Si el usuario está autenticado, ir al chat
  // Si no, ir a la página de autenticación
  const to = user ? '/chat' : '/auth';
  
  return (
    <Link to={to} className={className} {...props}>
      {children}
    </Link>
  );
};

export default AuthRedirect;
